import { useEffect, useRef } from 'react';
import { r, s } from '@/theme/tokens';
import { Stack } from '@/ui';
import { PolicyPageShell } from '@/ui/layout';
import { Section } from '@/ui/layout/Section';
import { Box } from '@/ui/primitives';
import { publicPageSurfaceBackground } from './publicSite/publicSurfaceTokens';
import type { ReactElement } from 'react';

const TERMLY_SCRIPT_ID = 'termly-jssdk';

type TermlyPolicyEmbedProps = {
  dataId: string;
};

export const TermlyPolicyEmbed = ({ dataId }: TermlyPolicyEmbedProps): ReactElement => {
  const embedRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (embedRef.current) {
      embedRef.current.setAttribute('name', 'termly-embed');
      embedRef.current.setAttribute('data-id', dataId);
    }

    const existingScript = document.getElementById(TERMLY_SCRIPT_ID);
    if (existingScript?.parentNode) {
      existingScript.parentNode.removeChild(existingScript);
    }

    const script = document.createElement('script');
    script.id = TERMLY_SCRIPT_ID;
    script.src = 'https://app.termly.io/embed-policy.min.js';
    script.async = true;
    document.body.appendChild(script);
  }, [dataId]);

  return (
    <PolicyPageShell>
      <Box sx={{ minHeight: '100dvh', display: 'flex', flexDirection: 'column' }}>
        <Stack gap="none" sx={{ flex: 1, minHeight: 0 }}>
          <Section paddingY="none">
            <Box
              sx={{
                backgroundColor: publicPageSurfaceBackground,
                minHeight: '100dvh',
                height: '100%',
                overflowY: 'auto',
                padding: s('none'),
                margin: s('none'),
                border: 'none',
                borderRadius: r('none'),
                '& iframe': {
                  display: 'block',
                  width: '100%',
                  minHeight: '100dvh',
                },
              }}
            >
              <div ref={embedRef} />
            </Box>
          </Section>
        </Stack>
      </Box>
    </PolicyPageShell>
  );
};
